import type { SearchParams } from '../types';

const objectToSearchParams = (obj: SearchParams) => {
  const searchParams = new URLSearchParams();

  Object.entries(obj).forEach(([key, value]) => {
    searchParams.append(key, value);
  });

  return searchParams.toString();
};

export { objectToSearchParams };
